var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"3533",
      name:"外部数据列",
      parentId:"TABLE_ID",
      parentName:"外部数据实体管理",
      parentPath:"/system/trans/outerTable",
      parentQuery:{
      },
      addForm:{
      },
      dataClass:2,
      col:[]
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }